export interface AppBase {
  id: number;
  name: string;
  appVersion: string;
  updateMessage: string;
  push: boolean;
  chat: boolean;
  content: boolean;
  link: boolean;
}

export interface AppDevice {
    id: number;
    name: string;
    device_checked_at?: string | null;  // ISO string or null
    last_seen_at?: string | null;
    vehicle_id?: number | null;
    company_id?: number | null;
    contact_id?: number | null;
    device_id: string;
    app_id?: number | null;
    app_version: string;
    os_name: string;
    os_version: string;
    device_model: string;
    app_name?: string;
    failed_to_get_messages?: string;
    number_of_messages?: string;

    
    messages?: AppDeviceMessage[]; // Related messages
  }

export function newAppDevice(): AppDevice {
    return {
      id: 0,
      name: "",
      device_id: "",
      company_id: 0,
      vehicle_id: 0,
      contact_id: 0,
      last_seen_at: "",
      device_checked_at: "",
      app_version: "",
      os_name: "",
      os_version: "",
      device_model: "",
    }
  }

  export interface AppDeviceMessage {
    id: number;
    name: string;
    appDeviceId?: number | null;
    messageType: string;
    jsonMessage?: string;
    readAt?: string | null;
    confirmedAt?: string | null;
    errorMessage?: string;
  }

  export function newAppDeviceMessage(): AppDeviceMessage {
    return {
      id: 0,
      name: "",
      appDeviceId: 0,
      messageType: "",
      jsonMessage: "",
      readAt: "",
      confirmedAt: "",
      errorMessage: "",
    }
  }


  export interface AppSetting {
    id: number;
    name: string;
    loaction: string;
    content: boolean;
    links: boolean;
    action: string;
  }

  export function newAppSetting(): AppSetting {
    return {
      id: 0,
      name: "",
      loaction: "",
      content: false,
      links: false,
      action: "",
    }
  }